/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_S7_Link_TextInputs */

const tr_servis_s7_link_text = /** @type {(inputs: Servis_S7_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gizlilik Politikası`)
};

const en_servis_s7_link_text = /** @type {(inputs: Servis_S7_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy Policy`)
};

const de_servis_s7_link_text = /** @type {(inputs: Servis_S7_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenschutzrichtlinie`)
};

const ru_servis_s7_link_text = /** @type {(inputs: Servis_S7_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Политика конфиденциальности`)
};

/**
* | output |
* | --- |
* | "Privacy Policy" |
*
* @param {Servis_S7_Link_TextInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_s7_link_text = /** @type {((inputs?: Servis_S7_Link_TextInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_S7_Link_TextInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_s7_link_text(inputs)
	if (locale === "de") return de_servis_s7_link_text(inputs)
	if (locale === "ru") return ru_servis_s7_link_text(inputs)
	return tr_servis_s7_link_text(inputs)
});